import { render, staticRenderFns } from "./ProductDistributeView.vue?vue&type=template&id=40c6ae3b&scoped=true"
import script from "./ProductDistributeView.vue?vue&type=script&lang=js"
export * from "./ProductDistributeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c6ae3b",
  null
  
)

export default component.exports